import React from 'react';
const pains = [{
  emoji: '😰',
  title: 'Creative Burnout',
  description: "You arrive at the studio exhausted after spending hours looking for new sequences on social media that you don't know how to connect."
}, {
  emoji: '🍃',
  title: 'Lack of Structure',
  description: "Your classes lose their flow. You improvise transitions and fear your students aren't progressing logically."
}, {
  emoji: '📱',
  title: 'Information Overload',
  description: "You search Google and find contradictory poses. You don't know what structure is most effective for a 60-minute session."
}, {
  emoji: '😩',
  title: 'Massive Mental Load',
  description: 'Managing students and planning stops you from enjoying your true passion for Yoga.'
}];
export function PainSection() {
  return <section className="py-8 px-4 bg-white border-y-4 border-brand-rose/20" data-id="element-114">
      <div className="max-w-4xl mx-auto" data-id="element-115">
        <h2 className="text-2xl sm:text-3xl font-serif font-extrabold text-center text-brand-graphite mb-2 uppercase tracking-tight" data-id="element-116">
          DO YOU RECALL THIS?
        </h2>

        <p className="text-base sm:text-lg text-brand-graphite/90 font-medium text-center mb-6 max-w-2xl mx-auto leading-snug" data-id="element-117">
          You love teaching, but does preparation steal all your free time?
          <br className="hidden sm:block" data-id="element-118" />
          If you are a Yoga instructor, you probably know one of these
          situations:
        </p>

        <div className="grid sm:grid-cols-2 gap-3" data-id="element-119">
          {pains.map((pain, i) => <div key={i} className="bg-brand-cream p-4 rounded-lg border-2 border-brand-rose/30 shadow-sm flex flex-col items-center text-center sm:items-start sm:text-left sm:flex-row gap-3" data-id="element-120">
              <div className="text-3xl shrink-0" data-id="element-121">{pain.emoji}</div>
              <div data-id="element-122">
                <h3 className="text-base font-bold text-brand-petrol mb-1 uppercase tracking-wide" data-id="element-123">
                  {pain.title}
                </h3>
                <p className="text-brand-graphite/80 text-sm font-medium leading-snug" data-id="element-124">
                  {pain.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}